import ComponentWithSocket from '../../../lib/component';
import { Component, Watch } from 'vue-property-decorator';
import moment from 'moment';

import * as Store from '../../../store';

@Component
export default class UsersVerification extends ComponentWithSocket {
    public data: {
        verifications: any[];
        perPage: number;
        currentPage: number;
        verificationsCount: number;
        searchQuery: string;
        isSearching: boolean;
    } = {
        verifications: [],
        perPage: 50,
        currentPage: 1,
        verificationsCount: 0,
        searchQuery: this.$attrs.s ? this.$attrs.s : '',
        isSearching: false,
    };

    rejectReason: string = '';
    address: string = '';
    city: string = '';
    county: string = '';
    country: string = 'Romania';
    selectedVerification: any = {};

    get tableFields() {
        return [
            { key: 'avatar', label: '' },
            { key: 'name', label: 'Nume' },
            { key: 'contact', label: 'Contact' },
            { key: 'documents', label: 'Documente' },
            { key: 'tip', label: 'Tip' },
            { key: 'date', label: 'Data' },
            { key: 'status', label: 'Status' },
            { key: 'actions', label: 'Actiuni' },
        ];
    }

    @Watch('data.searchQuery')
    onSearchQueryChanged(val: string, oldVal: string) {
        if (!this.data.isSearching) {
            setTimeout(() => {
                this.data.isSearching = false;
                this.data.currentPage = 1;
                this.insertParam('s', this.data.searchQuery);

                this.reloadVerifications(1);
            }, 1000);
        }
        this.data.isSearching = true;
    }

    constructor() {
        super();

        this.wsListener.onGet(
            'admin.verifications',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    this.data.verifications = data.verifications;
                    this.data.verificationsCount = data.verificationsCount;
                }
            },
        );

        this.wsListener.onPost(
            'admin.verifications.review',
            (success: boolean, data: any) => {
                if (success) {
                    this.wsListener.sendGet('admin.verifications');
                    Store.commitLoaderVisibility(this.$store, false);
                } else {
                    Store.commitLoaderVisibility(this.$store, false);
                    alert(data);
                }
            },
        );
    }

    public reloadVerifications(page: any = this.data.currentPage) {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.verifications', {
            searchQuery: this.data.searchQuery,
            perPage: this.data.perPage,
            currentPage: page,
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.verifications', {
            searchQuery: this.data.searchQuery,
            perPage: this.data.perPage,
            currentPage: this.data.currentPage,
        });
    }

    acceptVerification(verification: any) {
        this.selectedVerification = verification;

        let ref: any = this.$refs['accept-modal'];

        ref.show();
    }

    doAcceptVerification() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('admin.verifications.review', {
            verification: this.selectedVerification._id,
            address: {
                street: this.address,
                city: this.city,
                county: this.county,
                country: this.country,
            },
            accepted: true,
        });
    }

    rejectVerification(verification: any) {
        this.selectedVerification = verification;

        let ref: any = this.$refs['reason-modal'];

        ref.show();
    }

    doRejectVerification() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('admin.verifications.review', {
            verification: this.selectedVerification._id,
            accepted: false,
            reason: this.rejectReason,
        });
    }

    public insertParam(key: any, value: any) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        // kvp looks like ['key1=value1', 'key2=value2', ...]
        let kvp = document.location.search.substr(1).split('&');
        let i = 0;

        for (; i < kvp.length; i++) {
            if (kvp[i].startsWith(key + '=')) {
                let pair = kvp[i].split('=');
                pair[1] = value;
                kvp[i] = pair.join('=');
                break;
            }
        }

        if (i >= kvp.length) {
            kvp[kvp.length] = [key, value].join('=');
        }

        // can return this or...
        let params = kvp.join('&');

        // reload page with new params
        window.history.replaceState(undefined, '', '?' + params);
    }

    formatDate(dateString: string): string {
        return moment(dateString).format('DD-MM-YYYY HH:mm');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/users/verifications/index.ts